export default {
  PERSONAL: "personal",
  CORPORATE: "corporate",
  PERSONAL_AND_CORPORATE: "personal_and_corporate"
};
